import { ButtonHTMLAttributes } from "react";
import { Button } from "./Button.style";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
}

export default function FormButton({ children, fullWidth, variant, ...props }: ButtonProps) {
  return (
    <Button fullWidth={fullWidth} variant={variant} {...props}>
      {children}
    </Button>
  );
}